import { useLayout } from '@hana/shell';
import { HrCompact } from './HrCompact';
import { HrOverview } from './HrOverview';

/** Máy bàn: Mint-HR (tổng quan · nhân sự · cơ cấu). iPad / điện thoại: Mint-HR-iPad / -Phone. */
export function HrScreen() {
  const layout = useLayout();
  return layout === 'pad' || layout === 'phone' ? <HrCompact phone={layout === 'phone'} /> : <HrOverview />;
}
